import { componentApi } from "..";


//Date is set server side
export async function updateWarrantyStartDate(
    relevantSystemId: string,
): Promise<void> {
  try {
      await componentApi.updateAssignmentAttributes({
        systemId: relevantSystemId
      })

      console.log("Updated assignement date for robot " + relevantSystemId)
  } catch (e) {
    throw new Error(
      `Robot mit id ${relevantSystemId} konnte neues assignement Datum nicht zugewiesen bekommen: ${(e as Response).status}${
        (e as Response).statusText
      }`,
    )
  }
}
